import { FormControl, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { BorderedInputAdornment } from '~/modules/@shared/components';
import { text } from '~/modules/@shared/helpers/text';
import { useValidateAmount } from '~/modules/@shared/hooks/useValidateAmount';
import { CreateInvoiceForm } from '../../helpers/createInvoiceSchema';

export default function InvoiceAmountField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateInvoiceForm>();

  const name = 'amount';
  const validateAmount = useValidateAmount({ name });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <TextField
            {...field}
            {...validateAmount}
            value={value ?? ''}
            InputProps={{
              startAdornment: <BorderedInputAdornment position="start">$</BorderedInputAdornment>,
              inputProps: {
                min: 0,
                step: '0.01',
              },
            }}
            error={!!errors.amount}
            helperText={text(errors.amount?.message)}
            FormHelperTextProps={{ error: true }}
          />
        </FormControl>
      )}
    />
  );
}
